import { Report, Reporter } from './types';

export abstract class BaseReporter implements Reporter {
    abstract processReport(report: Report): Promise<void>;
    async teardown(): Promise<void> {}
}
